(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["win-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('cart:update', () => { fetch(`${window.Shopify.routes.root}cart.js`).then(r => r.json()).then(cart => { document.querySelectorAll('.win-cart-count').forEach(el => { el.textContent = cart.item_count; }); }).catch(() => {}); });
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.win-mobile-menu[open]').forEach(el => el.removeAttribute('open')); });

  } catch(e) { console.error(e); }
})();
})();
